<template>
  <button @click="$parent.close()" class="popover__close"></button>
</template>

<script>
  export default {
    name: 'simple-close'
  }
</script>
